import React from "react";

import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";
import LogoutIcon from "@mui/icons-material/Logout";
import MenuIcon from "@mui/icons-material/Menu";
import NotificationImportantIcon from "@mui/icons-material/NotificationImportant";
import NotificationsIcon from "@mui/icons-material/Notifications";
import MuiAppBar from "@mui/material/AppBar";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { styled } from "@mui/material/styles";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";

import { logout } from "../../../functions/logout";

const drawerWidth = 290;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  backgroundColor: theme.palette.mode === "dark" ? theme.palette.background.default : "#fff",
  color: theme.palette.mode === "dark" ? theme.palette.text.primary : "#000",
  boxShadow:
    theme.palette.mode === "dark"
      ? "0px 2px 4px rgba(255, 255, 255, 0.1)"
      : "0px 2px 4px rgba(0, 0, 0, 0.1)",
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const AppHeader = ({
  open,
  toggleDrawer,
  mode,
  modeShift,
  notificacoes,
  novaNotific,
  setNovaNotific,
  nome,
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorElNotify, setAnchorElNotify] = React.useState(null);

  const openA = Boolean(anchorEl);
  const openAN = Boolean(anchorElNotify);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClickNotify = (event) => {
    setNovaNotific(false);
    setAnchorElNotify(event.currentTarget);
  };

  const handleCloseNotify = () => {
    setAnchorElNotify(null);
  };

  return (
    <AppBar open={open}>
      <Toolbar sx={{ pr: "24px" }}>
        <IconButton
          edge="start"
          color="inherit"
          aria-label="open drawer"
          onClick={toggleDrawer}
          sx={{
            marginRight: "36px",
            ...(open && { display: "none" }),
          }}
        >
          <MenuIcon />
        </IconButton>
        <Typography component="h1" variant="h6" color="inherit" noWrap sx={{ flexGrow: 1 }}>
          <img
            src={mode === "light" ? "./logoPortalDark.svg" : "./logoPortalWhite.svg"}
            style={{ height: "55px" }}
            alt="Logo"
          />
        </Typography>
        <IconButton color="inherit" onClick={handleClickNotify}>
          {novaNotific ? <NotificationImportantIcon /> : <NotificationsIcon />}
        </IconButton>
        <Menu
          anchorEl={anchorElNotify}
          open={openAN}
          onClose={handleCloseNotify}
          onClick={handleCloseNotify}
        >
          {notificacoes}
        </Menu>
        <IconButton color="inherit" onClick={modeShift}>
          {mode === "light" ? <DarkModeIcon /> : <LightModeIcon />}
        </IconButton>
        <IconButton onClick={handleClick}>
          <Avatar sx={{ bgcolor: "#1976d2" }}>{nome[0]}</Avatar>
        </IconButton>
        <Menu anchorEl={anchorEl} open={openA} onClose={handleClose} onClick={handleClose}>
          <MenuItem onClick={logout}>
            <ListItemIcon>
              <LogoutIcon fontSize="small" />
            </ListItemIcon>
            Sair
          </MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
};

export default AppHeader;
